import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserType } from '../../../Shared/Enums/UserType';
import { AuthService } from '../../../Shared/Services/auth.service';
import { ContractsWarrantiesService } from '../../../Services/contracts-warranties.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import { CostCalcVM } from '../../../Model/contracts-warranties/submit-contract/CostCalcVM';
import { environment } from '../../../../environments/environment'
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { DtoClientForViewVM } from '../../../Model/clients/DtoClientForViewVM';
import { AddPaymentsComponent } from '../add-payments/add-payments.component';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomAddPaymentsVM } from '../../../Model/contracts-warranties/submit-contract/CustomAddPaymentsVM';
import { DialogService } from '../../../Shared/Services/dialog.service';
import { SharedService } from '../../../Shared/Services/shared.service';
import { ClientService } from '../../../Services/client.service';

@Component({
  selector: 'app-create-contract',
  templateUrl: './create-contract.component.html',
  styleUrl: './create-contract.component.scss'
})
export class CreateContractComponent {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  @Input() Client?: DtoClientForViewVM;
  @Output() createContract = new EventEmitter<boolean>();
  imgPath: string = environment.ImgUrl;
  CostCalc!: CostCalcVM[];
  selectedIds?: number[] = [];
  formErrors: string[] = [];
  form!: FormGroup;
  TotalCost?: number;
  allChecked?: boolean = false;
  fromPrice?: boolean = false;

  constructor(private auth: AuthService, private router: Router, private api: ContractsWarrantiesService, private clientApi: ClientService,
    private spinner: NgxSpinnerService, private toastrService: CustomToastrService, private translate: TranslateService,
    private route: ActivatedRoute, private dialogService: DialogService, private shared: SharedService) { }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      this.spinner.show();
      if (!this.Client) {
        this.route.params.subscribe(params => {
          const id = params['id'];
          this.CostCalcToClient(id);
          this.GetClientData(id);
          this.fromPrice = true;
        });
      } else {
        this.fromPrice = false;
        this.CostCalcToClient(this.Client?.id);
      }

      this.form = new FormGroup({});
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetClientData(clientId: any) {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      this.clientApi.GetClientData(clientId)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data: any) => {
            this.spinner.hide();
            if (data.isCompleted) {
              this.Client = data.result.payload;
            }
          },
          error: (error: any) => {
            this.spinner.hide();
            this.toastrService.showErrorToast('Error', "SomethingWentWrong");
          }
        });
    }
    else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  initForm() {
    for (let i = 0; i < this.CostCalc.length; i++) {
      this.form.addControl('CheckedProduct_' + this.CostCalc[i].id, new FormControl('', [Validators.required]));
      this.form.addControl('InstallationDate_' + this.CostCalc[i].id, new FormControl('', [Validators.required]));
    }
  }

  CostCalcToClient(clientId?: number) {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      this.api.CostCalcToClient(clientId)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          {
            next: (data: any) => {
              this.spinner.hide();
              this.CostCalc = data;
              this.initForm();
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  ChooseProduct(event: any, id?: number) {
    if (id != null) {
      if (event.checked) {
        this.selectedIds?.push(id);
      } else {
        this.selectedIds?.splice(this.selectedIds.indexOf(id), 1);
      }
    }
  }


  ClacTotalCost(totalPrice?: number, count?: number) {
    return this.shared.ClacTotalCost(totalPrice, count);
  }

  CheckOneCheckboxRequired(cat?: any): boolean {
    let forms = this.form;
    let controls = this.form.controls;
    let checkedCount = 0;
    Object.keys(controls).map(a => {
      if (a.includes(cat)) {
        var value = forms.controls[a].value;
        if (value == '' || value == null || !value)
          checkedCount++;
      }
    })

    return checkedCount == this.CostCalc.length
  }

  CheckInstallationDateRequired(cat?: any): boolean {
    let forms = this.form;
    let controls = this.form.controls;
    let checkedCount = 0;
    Object.keys(controls).map(a => {
      let index = a.split('_')[1];
      if (forms.controls['CheckedProduct_' + index].value && a.includes(cat)) {
        var value = forms.controls[a].value;
        if (value == '' || value == null)
          checkedCount++;
      }
    })

    return checkedCount > 0;
  }

  EnterPaymentsNumber() {
    this.formErrors = [];
    const errors = [];
    let isNotValid = false;
    if (this.CheckOneCheckboxRequired('CheckedProduct')) {
      errors.push('EnterCheckedProduct');
      isNotValid = true;
    }

    if (!isNotValid && this.CheckInstallationDateRequired('InstallationDate')) {
      errors.push('EnterInstallationDate');
      isNotValid = true;
    }

    if (isNotValid) {
      errors.forEach(item => {
        this.formErrors.push(this.translate.instant(item));
      });

      return;
    }

    this.SumbitEnterPaymentsNumber();
  }

  SumbitEnterPaymentsNumber() {
    this.dialogService.confirmDialog({
      titleKey: 'confirmation',
      messageKey: 'AreYouSuretoEnterPaymentsNumber',
      confirmTextKey: 'Yes',
      cancelTextKey: 'No'
    }).subscribe(isConfirmed => {
      if (isConfirmed) {
        this.ConfirmSumbitEnterPaymentsNumber();
      }
    });
  }

  ConfirmSumbitEnterPaymentsNumber() {
    let CostCalc: CostCalcVM[] = [];
    this.CostCalc.map((a: CostCalcVM) => {
      let id = a.id;
      let Cost = a;
      if (id != null && this.selectedIds?.includes(id)) {
        Object.keys(this.form.controls).map(a => {
          let index = a.split('_')[1];
          if (index === id.toString() && this.form.controls['CheckedProduct_' + index].value
            && a.includes('InstallationDate')) {
            var value = this.form.controls[a].value;
            Cost.InstallationDate = value;
          }
        });

        CostCalc.push(Cost);
      }
    });

    let data: CustomAddPaymentsVM = {
      CostCalc: CostCalc,
      Client: this.Client,
      IsAddPaymentsNumbers: true,
      fromPrice: this.fromPrice
    }

    this.dialogService.openDialog(AddPaymentsComponent, data);
  }

  Cancel() {
    if (this.form.touched) {
      this.dialogService.confirmDialog({
        titleKey: 'confirmation',
        messageKey: 'AreYouSuretoBackWithoutSave',
        confirmTextKey: 'Yes',
        cancelTextKey: 'No'
      }).subscribe(isConfirmed => {
        if (isConfirmed) {
          if (this.fromPrice) {
            this.router.navigateByUrl('dashboard/price-offers');
          }
          else {
            this.createContract.emit(false);
          }
        }
      });
    }
    else {
      if (this.fromPrice) {
        this.router.navigateByUrl('dashboard/price-offers');
      }
      else {
        this.createContract.emit(false);
      }
    }
  }

  CheckAll() {
    this.allChecked = !this.allChecked;
    for (let i = 0; i < this.CostCalc.length; i++) {
      if (this.allChecked) {
        this.selectedIds?.push(this.CostCalc[i].id!);
        this.form.controls["CheckedProduct_" + this.CostCalc[i].id].setValue(this.allChecked);
      } else {
        this.selectedIds?.splice(this.CostCalc[i].id!, 1);
      }
    }
  }
}
